import React from 'react';
import { THEME } from '../../constants/theme';
import './Card.css';

const Card = ({ 
  children, 
  className = '', 
  padding = 'lg',
  shadow = 'md',
  borderRadius = 'lg',
  ...props 
}) => {
  const cardStyle = {
    padding: THEME.spacing[padding],
    borderRadius: THEME.borderRadius[borderRadius],
  };

  return (
    <div 
      className={`card card-${shadow} ${className}`}
      style={cardStyle}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;